// extracted by mini-css-extract-plugin
export default {"list":"A7PHcShhSOOx_PYhHQ5RE","responsive":"_2oWXqHbJs7DGG_f8Fqbp96","page-projects":"_2Zc-tG-uxzzqMw6cEKKigd","startSlideShowButtonRow":"_2iEer2H8yWt9UlLQJjSyaB"};